import React from 'react';
import Button from '@mui/material/Button';
import {useWizard} from './WizardNode';
export default function WizardBackNode({children='Back',...props}:any){
 const wizard=useWizard();
 return <Button type="button" {...props} onClick={wizard?.back}>{children}</Button>
}
